import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getStyles } from './styles';

const RequestQuote = () => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';
const [sent, setSent] = useState(false);

  // responsiveness flag
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia('(max-width: 768px)');
    const handler = (ev) => setIsMobile(ev.matches);
    setIsMobile(mq.matches);
    // modern browsers support addEventListener on MediaQueryList
    if (mq.addEventListener) {
      mq.addEventListener('change', handler);
      return () => mq.removeEventListener('change', handler);
    } else {
      // fallback for older browsers
      mq.addListener(handler);
      return () => mq.removeListener(handler);
    }
  }, []);

  const styles = getStyles(isRtl, isMobile);

  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    website: '',
    city: '',
    deliveryPlace: '',
    product: '',
    quantity: '',
    package: [],
    specifications: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleChecks = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      package: checked ? [...prev.package, name] : prev.package.filter((p) => p !== name),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const selectedProduct =
      document.querySelector(`#product option[value="${formData.product}"]`)?.textContent ||
      formData.product ||
      '';

    const emailBody = `
      Dear Al Rabie Group,

      Please find my quote request details below:

      Personal Information:
      -------------------
      Name: ${formData.name}
      Company Name: ${formData.company}
      Company website: ${formData.website}
      Email: ${formData.email}
      Phone: ${formData.phone}
      City: ${formData.city}
      Delivery Place: ${formData.deliveryPlace}

      Product Details:
      --------------
      Product: ${selectedProduct}
      Quantity: ${formData.quantity}
      Packaging: ${formData.package.join(', ')}

      Specifications:
      -------------
      ${formData.specifications}

      Additional Message:
      ----------------
      ${formData.message}


      Best regards,
      ${formData.name}
    `.trim();


    const mailtoUrl = `mailto:sales@alrabiegroup.com?subject=${encodeURIComponent(
      'Quote Request - ' + selectedProduct
    )}&body=${encodeURIComponent(emailBody)}`;

    // Open default mail client
    window.location.href = mailtoUrl;
    setFormData({
    name: '',
    company: '',
    email: '',
    phone: '',
    website: '',
    city: '',
    deliveryPlace: '',
    product: '',
    quantity: '',
    package: [],
    specifications: '',
    message: '',
  });
  setSent(true);
  setTimeout(() => setSent(false), 5000); // hide after 5s
  };

  return (
    <>
   
      <div style={styles.requestQuote}>
        <div style={styles.quoteHeader}>
          <h1 style={styles.quoteHeaderH1}>{t('navigation.requestQuote')}</h1>
          <p style={styles.quoteHeaderP}>{t('requestQuote.description')}</p>
        </div>

        <form onSubmit={handleSubmit} style={styles.quoteForm}>
          {/* row 1 */}
          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="name">
                <span style={styles.requiredMark}>*</span>
                {t('requestQuote.form.name')}
              </label>
              <input style={styles.input} id="name" name="name" value={formData.name} onChange={handleChange} required />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="company">
                <span style={styles.requiredMark}>*</span>
                {t('requestQuote.form.company')}
              </label>
              <input style={styles.input} id="company" name="company" value={formData.company} onChange={handleChange} required />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="email">
                <span style={styles.requiredMark}>*</span>
                {t('requestQuote.form.email')}
              </label>
              <input style={styles.input} id="email" name="email" type="email" value={formData.email} onChange={handleChange} required />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="phone">
                <span style={styles.requiredMark}>*</span>
                {t('requestQuote.form.phone')}
              </label>
              <input style={styles.input} id="phone" name="phone" type="tel" value={formData.phone} onChange={handleChange} required />
            </div>
          </div>

          {/* row 2 */}
          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="website">{t('requestQuote.form.website')}</label>
              <input style={styles.input} id="website" name="website" value={formData.website} onChange={handleChange} />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="city">{t('requestQuote.form.city')}</label>
              <input style={styles.input} id="city" name="city" value={formData.city} onChange={handleChange} />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="deliveryPlace">
                <span style={styles.requiredMark}>*</span>
                {t('requestQuote.form.deliveryPlace')}
              </label>
              <input style={styles.input} id="deliveryPlace" name="deliveryPlace" value={formData.deliveryPlace} onChange={handleChange} required />
            </div>
          </div>

          {/* row 3 */}
          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="product">
                <span style={styles.requiredMark}>*</span>
                {t('requestQuote.form.product')}
              </label>
              <select id="product" name="product" style={styles.select} value={formData.product} onChange={handleChange} required>
                <option value="">{t('requestQuote.form.selectProduct')}</option>
                <option value="Calcite">Calcite</option>
                <option value="Limestones">Limestone</option>
                <option value="Dolomite">Dolomite</option>
                <option value="Calcium Oxide">Calcium Oxide</option>
                <option value="Calcium Hydroxide">Calcium Hydroxide</option>
                <option value="Calcium Carbonate">Calcium Carbonate</option>
              </select>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="quantity">
                <span style={styles.requiredMark}>*</span>
                {t('requestQuote.form.quantity')}
              </label>
              <input style={styles.input} id="quantity" name="quantity" value={formData.quantity} onChange={handleChange} required placeholder={t('requestQuote.form.quantityPlaceholder')} />
            </div>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>
            <span style={styles.requiredMark}>*</span>
              {t('requestQuote.form.packaging')}
            </label>
            <div style={styles.checkboxGroup}>
              {['25Kg', '50kg', '1500kg', 'Dumper', 'Other'].map((pkg) => (
                <label key={pkg} style={styles.checkboxItem}>
                  <input type="checkbox" name={pkg} onChange={handleChecks} />
                  <span>{pkg}</span>
                </label>
              ))}
            </div>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label} htmlFor="specifications">{t('requestQuote.form.specifications')}</label>
            <textarea style={styles.textarea} id="specifications" name="specifications" value={formData.specifications} onChange={handleChange} placeholder={t('requestQuote.form.specificationsPlaceholder')} />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label} htmlFor="message">{t('requestQuote.form.message')}</label>
            <textarea style={styles.textarea} id="message" name="message" value={formData.message} onChange={handleChange} placeholder={t('requestQuote.form.messagePlaceholder')} />
          </div>

          <div>
            <button type="submit" style={styles.submitButton}>{t('requestQuote.form.submit')}</button>
          </div>
          {sent && <div style={{ color: 'green', marginTop: '10px' }}>✅ check your email client!</div>}
        </form>
      </div>

    </>
  );
};

export default RequestQuote;
